import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';
import { EVENTS } from '@r1-frontend/shared/constants/analytics';
import DotNavigation from '@r1-frontend/ui-react/components/navigation/dotNavigation';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import HeaderLanding from '@r1-frontend/ui-react/organisms/ForLanding';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import React from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';

import SectionArchive from '~/src/components/Catchup/SectionArchive';
import SectionDevices from '~/src/components/Catchup/SectionDevices';
import SectionFAQ from '~/src/components/Catchup/SectionFAQ';
import SectionFunctions from '~/src/components/Catchup/SectionFunctions';
import SectionOrder from '~/src/components/Catchup/SectionOrder';
import SectionWelcome from '~/src/components/Catchup/SectionWelcome';
import { PRODUCTS, SERVICE } from '~/src/constants';
import Swipe from '~/src/features/catchup/swipe';
import { connectedProducts } from '~/src/helpers/clientInfo';
import { getCurrentBreakpoint, getMedia } from '~/src/helpers/layout';

const SECTIONS = [
    {
        title: 'Описание',
        link: 'main',
        theme: 'whiteTransparent',
        id: 'sectionMain',
    },
    {
        title: 'Возможности',
        link: 'advantage',
        theme: 'black',
        id: 'sectionAdvantage',
    },
    {
        title: 'Архив',
        link: 'archive',
        theme: 'black',
        id: 'sectionArchive',
    },
    {
        title: 'Устройства',
        link: 'devices',
        theme: 'whiteTransparent',
        id: 'sectionDevices',
    },
    {
        title: 'Подключить услугу',
        link: 'order',
        theme: 'whiteTransparent',
        id: 'sectionOrder',
    },
];

const Container = styled(Swipe)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;

    @media ${getMedia('tablet')} {
        left: 0;
        position: relative;
        height: auto;
        width: 100%;
        display: block;
    }
`;

const Header = styled(HeaderLanding)`
    position: fixed;
    top: 0;
    left: ${p => p.withNewMenu ? '0' : '125px'};
    right: 0;
    width: auto;
    z-index: 19;
    transition-property: background;
    transition-duration: 0.4s;
    transition-timing-function: ease-out;
    padding-left: 114px;
    padding-right: 114px;

    @media only screen and ${getMedia('desktop', 'tablet')} {
        padding-left: 80px;
        padding-right: 80px;
    }

    @media ${getMedia('tablet')} {
        padding-left: 18px;
        padding-right: 18px;
        left: 0;
        top: 50px;
    }

    @media (max-width: 767px) {
        top: 100px;
    }
`;

const HeaderLink = styled.a`
    margin-right: 45px;
    text-decoration: none;
    ${FONTS.S};
    transition: color 0.4s ease-out;

    ${({ isActive, theme }) => {
        if (isActive) {
            return css`color: #56CCF2;`;
        } else if (theme === 'black') {
            return css`color: ${COLORS.TextWhite};`;
        } else {
            return css`color: ${COLORS.TextPrimary};`;
        }
    }}

    ${({ transitionDelay }) => {
        return css`transition-delay: ${transitionDelay}s;`;
    }}

    @media only screen and ${getMedia('desktop', 'tablet')} {
        ${FONTS.XS};
        margin-right: 35px;
    };

    @media only screen and ${getMedia('tablet', 'phone')} {
        display: none;

        &[href="#faq"] {
            display: block;
        }
    };

    @media only screen and ${getMedia('phone')} {
        display: none;
    }
`;

const Dots = styled(DotNavigation)`
    position: fixed;
    right: 73px;
    z-index: 19;
    top: 50%;
    height: auto;
    width: auto;
    display: block;
    transform: translateY(-50%);

    @media only screen and ${getMedia('desktop', 'tablet')} {
        right: 40px;
    }

    @media only screen and ${getMedia('tablet')} {
        display: none;
    }

    & > * + * {
        margin-top: 14px;
    }
`;

const FAQPopup = styled(DefaultPopup)`
    * {
        font-family: inherit;
    }
`;

class CatchupLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            popupFAQIsOpen: false,
            breakpoint: getCurrentBreakpoint(),
            activeIndex: 0,
            prevIndex: 0,
        };

        this.isAnimationEnd = true;
    }

    next() {
        if (this.state.activeIndex < SECTIONS.length - 1) {
            this.change(this.state.activeIndex + 1);
        }
    }

    prev() {
        if (this.state.activeIndex > 0) {
            this.change(this.state.activeIndex - 1);
        }
    }

    getDeltaY = (event) => {
        if (event.wheelDelta && !event.deltaY) {
            this.getDeltaY = (event) => {
                return event.wheelDelta * -1;
            };
        } else {
            this.getDeltaY = (event) => {
                return event.deltaY;
            };
        }

        return this.getDeltaY(event);
    }

    onWheel = (e) => {
        const delta = this.getDeltaY(e);
        if (delta > 0) {
            this.next();
        } else if (delta < 0) {
            this.prev();
        }
    }

    checkBreakPoint = () => {
        const current = getCurrentBreakpoint();
        if (this.state.breakpoint !== current) {
            this.setState({ breakpoint: current });
        }
    }

    onResize = () => {
        if (this.resizeTimeout !== undefined) {
            clearTimeout(this.resizeTimeout);
        }

        this.resizeTimeout = setTimeout(() => {
            this.checkBreakPoint();
            this.updateSectionsOffsets();
        }, 100);
    }

    getIndexSection(section) {
        const keys = Object.keys(SECTIONS);
        for (let i = 0; i <= keys.length; i += 1) {
            if (SECTIONS[keys[i]].link === section.link) {
                return i;
            }
        }

        return 0;
    }

    dotClick = (activePage) => {
        const index = this.getIndexSection(activePage);
        this.change(index);
    }

    toggleFAQPopup = popupFAQIsOpen => {
        this.setState({ popupFAQIsOpen });
    };

    headerFaqClick = e => {
        if (e.cancelable) {
            e.preventDefault();
        }

        if (this.state.breakpoint !== 'tablet') {
            this.toggleFAQPopup(true);
        } else {
            document.getElementById('sectionFaq').scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
    }

    onScroll = () => {
        if (this.state.breakpoint !== 'tablet' && this.state.breakpoint !== 'phone') {
            return;
        }

        if (this.scrollTimeout !== undefined) {
            clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            let activeSection;
            for (let i = 0; i < this.sectionsOffsets.length; i += 1) {
                if (scrollTop >= this.sectionsOffsets[i].top) {
                    activeSection = this.sectionsOffsets[i];
                }
            }

            this.setState({
                prevIndex: this.state.activeIndex,
                activeIndex: this.getIndexSection(activeSection),
            });
        }, 50);
    }

    headerButtonClick = () => {
        if ((this.state.breakpoint === 'tablet' || this.state.breakpoint === 'phone')) {
            document.getElementById('sectionOrder').scrollIntoView({ block: 'start', behavior: 'smooth' });
        } else {
            const index = this.getIndexSection({ link: 'order' });
            this.change(index);
        }
    }

    onButtonClickSectionWelcome = e => {
        if (e.cancelable) {
            e.preventDefault();
        }
        this.headerButtonClick();
        dataLayerPush({
            event: EVENTS.UAevent,
            category: 'service catchup',
            label: '',
            action: 'btn click on connect on the first screen',
        });
    };

    changeSlideSwipe = ({ detail }) => {
        if (detail.full.pointerType === 'mouse') {
            return;
        }

        if (detail.dir === 'up' || detail.dir === 'left') {
            this.next();
        } else if (detail.dir === 'down' || detail.dir === 'right') {
            this.prev();
        }
    }

    change(activeIndex) {
        if (this.state.breakpoint === 'tablet' || this.state.breakpoint === 'phone') {
            return;
        }
        if (this.isAnimationEnd === false) {
            return;
        }
        this.isAnimationEnd = false;

        this.setState({
            prevIndex: this.state.activeIndex,
            activeIndex,
        });

        setTimeout(() => {
            this.isAnimationEnd = true;
        }, 1500);
    }

    onKeyUp = (e) => {
        if (e.keyCode === 39 || e.keyCode === 40) {
            this.next();
        } else if (e.keyCode === 37 || e.keyCode === 38) {
            this.prev();
        }
    }

    componentDidMount() {
        document.addEventListener('mousewheel', this.onWheel);
        document.addEventListener('wheel', this.onWheel);
        document.addEventListener('MozMousePixelScroll', this.onWheel);
        document.addEventListener('keyup', this.onKeyUp);
        window.addEventListener('resize', this.onResize);
        window.addEventListener('scroll', this.onScroll);

        this.checkBreakPoint();

        if (this.state.breakpoint === 'tablet' || this.state.breakpoint === 'phone') {
            this.updateSectionsOffsets();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousewheel', this.onWheel);
        document.removeEventListener('wheel', this.onWheel);
        document.removeEventListener('MozMousePixelScroll', this.onWheel);
        document.removeEventListener('keyup', this.onKeyUp);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onScroll);
    }

    getOffsetElement(element_) {
        const rect = element_.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return rect.top + scrollTop;
      }

    updateSectionsOffsets() {
        this.sectionsOffsets = SECTIONS.map((section) => {
            const element = document.getElementById(section.id);

            return {
                id: section.id,
                top: this.getOffsetElement(element) - 55,
                link: section.link,
            };
        });
    }

    getDelay(prevSection, activeSection) {
        if (this.state.breakpoint === 'tablet' || this.state.breakpoint === 'phone') {
            return 0;
        }

        if (prevSection === 'main' && activeSection === 'advantage') {
            return 0.8;
        } else if (prevSection === 'advantage' && activeSection === 'main') {
            return 0.8;
        } else if (prevSection === 'advantage' && activeSection === 'archive') {
            return 0.8;
        } else if (prevSection === 'archive' && activeSection === 'advantage') {
            return 0.8;
        } else if (prevSection === 'main' && activeSection === 'archive') {
            return 0.8;
        } else if (prevSection === 'archive' && activeSection === 'main') {
            return 0.8;
        } else {
            return 0;
        }
    }

    setButtonText = () => {
        const connectedProduct = connectedProducts(this.props.auth, PRODUCTS.content, SERVICE.viewManagement);
        if (this.props.auth.isAuth && connectedProduct) {
            if (this.state.breakpoint === 'phone') {
               return 'Отключить';
            }
            return 'Управление услугой';
        }
        if (this.state.breakpoint === 'phone') {
            return 'Подключить';
        }
        return 'Подключить услугу';
    }


    render() {
        const { price, ...props } = this.props;
        const { activeIndex, prevIndex, breakpoint, headerMenu, popupFAQIsOpen } = this.state;

        const activeSection = SECTIONS[activeIndex];
        const prevSection = SECTIONS[prevIndex];
        const theme = activeSection.theme;
        const animationDelay = this.getDelay(prevSection.link, activeSection.link);

        return <Container callBack={this.changeSlideSwipe} setting={{ lockTrack: false }} {...props}>
            <style>
                {
                    `#popup-wrapper {
                        position: relative;
                        z-index: 20;
                    }`
                }
            </style>

            <Header
                transitionDelay={animationDelay}
                theme={theme}
                menuList={headerMenu}
                actionCallback={this.headerButtonClick}
                title='Управляй просмотром'
                actionTitle={this.setButtonText()}
            >
                <HeaderLink
                    transitionDelay={animationDelay}
                    href='#faq'
                    theme={theme}
                    onClick={this.headerFaqClick}>Частые вопросы</HeaderLink>
            </Header>

            <Dots
                navList={SECTIONS}
                activateMenu={this.dotClick}
                dotSize='12px'
                active={activeSection}
            />

            <SectionWelcome
                id='sectionMain'
                breakpoint={breakpoint}
                activeSlide={activeSection}
                prevSlide={prevSection}
                onButtonClick={this.onButtonClickSectionWelcome}
                onTelevisionClick={() => {
                    this.next();
                }}
            />
            <SectionFunctions id='sectionAdvantage' breakpoint={breakpoint} activeSlide={activeSection} prevSlide={prevSection}/>
            <SectionArchive id='sectionArchive' breakpoint={breakpoint} activeSlide={activeSection} prevSlide={prevSection}/>
            <SectionDevices id='sectionDevices' breakpoint={breakpoint} activeSlide={activeSection} prevSlide={prevSection} />
            <SectionOrder id='sectionOrder' price={price} ref={this.orderSection} activeSlide={activeSection} prevSlide={prevSection} />
            { popupFAQIsOpen && <SectionFAQ id='sectionFaq' price={price} />}

            <FAQPopup
                width='1273px'
                onClose={() => this.toggleFAQPopup(false)}
                isOpen={popupFAQIsOpen}
            >
                <SectionFAQ price={price} />
            </FAQPopup>
        </Container>;
    }
}

const mapStateToProps = ({ city, auth }) => ({
    city: city.currentCity,
    auth,
});

export default connect(
    mapStateToProps,
)(CatchupLayout);
